export default __webpack_public_path__ + "static/media/events4.0726d16e.png";